import React from 'react';
import styled from 'styled-components';
import { Grid, GridProps } from '@material-ui/core';

interface PaddedContainerProps extends Omit<GridProps, 'container'> {
    padding?: number;
}
/**
 * This component should be used as a top level container only.
 */
const PaddedContainer = styled(
    ({ padding, spacing, ...rest }: PaddedContainerProps) => (
        <Grid spacing={spacing} alignContent='flex-start' container {...rest} />
    )
)`
    ${({ theme, padding, spacing }) => `
        padding: ${theme.spacing(padding || (spacing && spacing / 2) || 0)}px;
    `}
    height: 100%;
`;

export default PaddedContainer;
